









































































































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import SelectNodeField from '@c/controls/selectControls/SelectNodeField.vue';
import {
  Condition,
  OrConditionsUnit,
  PMonitorTaskModule,
  SettingsTree,
} from '@v/system/modules/interfaces';
import PModuleHeaterMonitorGroupEditDialog from '@v/system/modules/forms/PModuleHeaterMonitorGroupEditDialog.vue';
import PModuleHeaterMonitorConditionEditDialog from '@v/system/modules/forms/PModuleHeaterMonitorConditionEditDialog.vue';
import TreeTable from './TreeTable.vue';
import PModuleHeaterMonitorTreeEditDialog from './PModuleHeaterMonitorTreeEditDialog.vue';
import axios from 'axios';
import IconButton from '@c/controls/IconButton.vue';
import CancelChangesDialog from '@c/CancelChangesDialog.vue';
import router from '@/router';
import nodeModule from '@/store/modules/entities/nodeModule';
import MonitorTaskTable from './MonitorTaskTable.vue';

@Component({
  components: {
    TreeTable,
    SelectNodeField,
    PModuleHeaterMonitorGroupEditDialog,
    PModuleHeaterMonitorConditionEditDialog,
    PModuleHeaterMonitorTreeEditDialog,
    IconButton,
    CancelChangesDialog,
    //    PModuleButtons,
    MonitorTaskTable,
  },
})
export default class MonitorTaskForm extends Vue {
  loading = false;
  saving = false;

  valid = true;

  showError = false;

  nodeName: any = null;

  @Prop({required: true})
  pmodule!: PMonitorTaskModule;

  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';

  nonEmptyNumberRule = (v: any) => v != null || 'Поле обязательно для заполнения';

  integerNumberRule = (v: any) => Number.isInteger(Number(v)) || 'Поле должно быть целым числом';

  settingsStore: SettingsTree[] = [];

  showMaxMessageCount = false;
  showChilds = false;
  showErrorCode = false;

  showSettings = false;

  get isShowStatesConditions() {
    return this.pmodule.states !== undefined;
  }

  get conditionsButtonDisabled() {
    return false;
    //    return (
    //      JSON.parse(this.pmodule.childs).length != 0 ||
    //      JSON.parse(this.pmodule.boundaryModules).length != 0
    //    );
  }

  get childButtonDisabled() {
    return this.settingsStore.length != 0; // || JSON.parse(this.pmodule.boundaryModules).length != 0;
  }

  get boundaryButtonDisabled() {
    return this.settingsStore.length != 0; // || JSON.parse(this.pmodule.child).length != 0;
  }

  nodeFieldClick() {
    router.push(`/nodes/${this.pmodule.nodes ? this.pmodule.nodes[0].node_id : 0}`); //TODO: fix it?
  }

  mounted() {
    try {
      this.settingsStore = JSON.parse(this.pmodule.states);
    } catch (e) {
      this.settingsStore = [];
    }
  }

  settingsDialog = PModuleHeaterMonitorGroupEditDialog;
  conditionDialog = PModuleHeaterMonitorConditionEditDialog;

  addTree() {
    const dialog = this.$refs.treeDialog as any;
    const options = {
      saveCallback: (data: any) => {
        dialog.$refs.form.reset();
        dialog.close();
        this.addTreeCallback(data);
      },
    };

    //TODO: CancelToken и axios должен быть в store
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const nextId = this.settingsStore.length + 1;
    const request = {
      data: {
        id: nextId,
        name: '',
        level: 0,
        unstatus: 0,
        or_conditions: [],
      },
    };

    dialog.openAsync(request, source, options);
  }

  async created() {
    if (this.pmodule.nodes && this.pmodule.nodes.length > 0) {
      const {data} = await nodeModule.edit(this.pmodule.nodes[0].node_id); //TODO: fix it?
      this.nodeName = data.name;
    }
    this.canShowSettings(this.pmodule);
  }

  canShowSettings(pmodule: PMonitorTaskModule) {
    if (
      pmodule.maxMessageCount == 0 &&
      !pmodule.notifyHttpType &&
      !pmodule.notifyHttpUri &&
      !pmodule.notifyHttpMessage
    )
      this.showSettings = false;
    else this.showSettings = true;
  }

  deleteTree(treeID: number) {
    const index = this.settingsStore
      .map(x => {
        return x.id;
      })
      .indexOf(treeID);

    this.settingsStore.splice(index, 1);
  }

  addTreeCallback(payload: SettingsTree) {
    this.settingsStore.push(payload);
  }

  addGroup(treeElementId: number, payload: OrConditionsUnit) {
    this.settingsStore.forEach((item: SettingsTree) => {
      if (item.id === treeElementId) {
        return {
          ...item,
          or_conditions: item.or_conditions.push(payload),
        };
      } else return item;
    });
  }

  deleteGroup(itemID: number, groupIndex: number) {
    this.settingsStore.forEach((item: SettingsTree) => {
      if (item.id === itemID) {
        return {
          ...item,
          or_conditions: item.or_conditions.splice(groupIndex, 1),
        };
      } else return item;
    });
  }

  addCondition(treeElementId: number, groupIndex: any, data: Condition) {
    this.settingsStore.forEach((item: SettingsTree) => {
      if (item.id === treeElementId) {
        item.or_conditions.forEach((group, index) => {
          if (index === groupIndex) {
            return {
              ...group,
              and_condition: group.and_conditions.push(data),
            };
          }
        });
        return {...item};
      } else return item;
    });
  }

  deleteCondition(itemID: number, groupIndex: number, settingIndex: number) {
    this.settingsStore.forEach((item: SettingsTree) => {
      if (item.id === itemID) {
        item.or_conditions.forEach((group, index) => {
          if (index === groupIndex) {
            return {
              ...group,
              and_condition: group.and_conditions.splice(settingIndex, 1),
            };
          }
        });
        return {...item};
      } else return item;
    });
  }

  updateChilds(jsonString: string) {
    this.pmodule.child = jsonString;
    this.onChange();
  }

  updateBoundaryModules(jsonString: string) {
    const arr = JSON.parse(jsonString);
    if (Array.isArray(arr)) {
      const obj: any = {};
      for (const s of arr) {
        obj[s] = [];
      }
      this.pmodule.boundaryModules = JSON.stringify(obj);
    } else {
      this.pmodule.boundaryModules = jsonString;
    }
    this.onChange();
  }

  checkModules() {
    const firstCondition = false; //JSON.parse(this.pmodule.childs).length != 0;
    const secondCondition = false; //JSON.parse(this.pmodule.boundaryModules).length != 0;
    const thirdCondition = this.settingsStore.length != 0;
    const conditionResult =
      Number(firstCondition) + Number(secondCondition) + Number(thirdCondition);

    if (conditionResult === 1 || conditionResult === 0) return true;
    return false;
  }

  async onSave() {
    const err_container = this.$refs.err_text as any;
    if (err_container) err_container.innerText = 'Обрабатываю...';

    // конвертирование формы дерева в текстовое поле
    this.pmodule.states = JSON.stringify(this.settingsStore);
    this.valid = await (this.$refs.form as any).validate();

    if (!this.valid) {
      const error = document.querySelector('div.error--text');
      error && (await this.$vuetify.goTo(error as HTMLElement));
      return;
    }

    if (this.checkModules()) this.$emit('save', err_container);
    else this.showError = true;
  }

  //переменная, сигнализирующая о внесенных и несохраненных изменениях на форме
  changed = false;

  // Действия при изменении поля
  async onChange() {
    this.changed = true;
  }

  get cancelChangesDialog() {
    return this.$refs.cancelChangesDialog as any;
  }

  back() {
    // если были внесены изменения на форме
    if (this.changed) {
      this.cancelChangesDialog.open('/monitor');
    } else router.push('/monitor');
  }
}
